import { useState, useEffect, useRef } from "react";
import { Modal, Button, message } from 'antd';
import { maintenanceService } from "../maintenanceService";
import { useMaintenanceModel } from "../maintenanceModel";
import { IMaintenanceDetail, IMaintenanceSearch, IMaintenanceField } from "../maintenanceType";
import { momentFormat, fmoney, numberParseChina } from "@/utils/utils";
import { useDictModel } from '@/views/base/dict/dictModel';
import { YhBox } from "@/components/YhBox";
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import "./settlePrint.css";
import useGlobalModel from "@/model/globalModel";

interface PropsType {
  printSettleVisible: boolean;
  setPrintSettleVisible: (visible: boolean) => void;
  printParam: IMaintenanceSearch;
  selectRows: IMaintenanceField[];
}

export const PrintMaintenanceSettle = (props: PropsType) => {
  const { printSettleVisible, setPrintSettleVisible, printParam, selectRows } = props;
  const { getTreeNodeName } = useDictModel();

  const [dataSource, setDataSource] = useState<any>([]);
  const [pageCount, setPageCount] = useState<number>(1);
  const [exporting, setExporting] = useState<boolean>(false);
  const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
  useEffect(() => {
    if (printSettleVisible) {
      maintenanceService.findAllDetail({ ...printParam, pageSize: 1000 }).then((res) => {
        let list: IMaintenanceDetail[] = res.retData;
        if (selectRows != null && selectRows.length > 0) {
          const codes = selectRows.map(e => e.maintenanceCode);
          list = list.filter(e => codes.includes(e.maintenanceCode));
        }
        list = list.map(e => {
          return {
            ...e,
            enterTime: e.enterTime ? momentFormat(e.enterTime, "YYYY-MM-DD") : '',
            completeTime: e.completeTime ? momentFormat(e.completeTime, "YYYY-MM-DD") : '',
            dispatchTime: e.dispatchTime ? momentFormat(e.dispatchTime, "YYYY-MM-DD") : '',
            stockIoTime: e.stockIoTime ? momentFormat(e.stockIoTime, "YYYY-MM-DD") : '',
          }
        })
        if (list.length !== 0) {
          setPageCount(list.length);
          setDataSource(list);
        }
        else {
          setPrintSettleVisible(false);
        }
      })
    }
  }, [printSettleVisible])

  const print = () => {
    const el: HTMLElement | null = document.getElementById('public-print-container');
    const iframe: any = document.createElement('IFRAME');
    let doc = null;

    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';

    document.body.appendChild(iframe);
    doc = iframe.contentWindow.document;

    // 引入打印的专有CSS样式，根据实际修改
    doc.write(`
      <html>
        <head>
          <LINK rel="stylesheet" type="text/css" href="./settlePrint.css">
          <style>
            @media print {
              .print-container {
                page-break-after: always;
              }
              .print-container:last-child {
                page-break-after: auto;
              }
            }
          </style>
        </head>
        <body>
          ${el?.innerHTML || ''}
        </body>
      </html>
    `);
    doc.close();

    // 获取iframe的焦点，从iframe开始打印
    iframe.contentWindow.focus();

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 500);

    if (navigator.userAgent.indexOf("MSIE") > 0) {
      document.body.removeChild(iframe);
    }
  };

  const exportToPdf = async () => {
    try {
      setExporting(true);
      const container = document.getElementById('public-print-container');
      if (!container) {
        message.error('未找到打印内容');
        setExporting(false);
        return;
      }

      // 获取所有打印页面元素
      const pages = container.querySelectorAll('.print-container');
      if (pages.length === 0) {
        message.error('未找到打印内容');
        setExporting(false);
        return;
      }

      // 创建一个临时的 iframe 来加载样式和内容
      const iframe = document.createElement('iframe');
      iframe.style.visibility = 'hidden';
      iframe.style.position = 'absolute';
      iframe.style.width = '1050px';
      iframe.style.height = '2000px';
      document.body.appendChild(iframe);

      // 在 iframe 中加载内容和样式
      const iframeDoc = iframe.contentWindow?.document;
      if (iframeDoc) {
        iframeDoc.open();
        iframeDoc.write(`
          <html>
            <head>
              <style>
                ul,li {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }
                .print-container {
                    width: 1050px;
                    position: relative;
                    overflow: hidden;
                    padding: 0;
                    margin: 0 auto;
                    font-size: 20px;
                    font-family: "FangSong" !important;
                    color: #000 !important;
                    font-weight: bold;
                }
                .print-container h2{
                    text-align: center;
                }
                .print-container ul{
                    margin:5px 0;
                }
                .print-container .header-odd{
                    display: flex;
                    justify-content: space-between;
                    font-family: "FangSong" !important;
                    color: #000 !important;
                }
                table {
                    width: 100%;
                    font-size: 20px;
                    font-family: "FangSong" !important;
                    color: #000 !important;
                }

                table,
                td {
                    border-collapse: collapse;
                    font-weight: 600;
                }
                .print-container table{
                    border-top:2px solid black;
                    border-left:2px solid black;
                    border-right:2px solid black;
                }
                .footer-table{
                    border-bottom:2px solid black;
                }

                /* 表格明细线 */
                .print-container td{
                    padding: 3px 5px;
                    text-align: center;
                    border: 1px solid black;
                }
                .print-container td:last-child{
                    width: 150px;
                }
                .finance .item-table td:nth-child(1),.finance .material-table td:nth-child(1) {
                    width: 6% !important;
                }
                .finance .item-table td:nth-child(2){
                    width: 18% !important;
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden !important;
                }
                .finance .material-table td:nth-child(2),.finance .material-table td:nth-child(3) {
                    width: 18% !important;
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden !important;
                }
                .finance .item-table td:nth-child(3) {
                    width: 25% !important;
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden !important;
                }
                .finance .material-table td:nth-child(4) {
                    width: 7% !important;
                }

                .finance .item-table td:nth-child(4),.finance .item-table td:nth-child(5) {
                    width: 9% !important;
                }
                .finance .material-table td:nth-child(5),.finance .material-table td:nth-child(6) {
                    width: 9% !important;
                }
                .finance .material-table td:nth-child(7) {
                    width: 10% !important;
                }
                .finance .material-table td:nth-child(8) {
                    width: 23% !important;
                }
                .finance .item-table td:nth-child(6){
                    width: 33% !important;
                }
                .print-center td {
                    text-align: center;
                }
              </style>
            </head>
            <body>
              ${container.innerHTML}
            </body>
          </html>
        `);
        iframeDoc.close();
      }

      // 等待样式和内容加载完成
      await new Promise(resolve => setTimeout(resolve, 500));

      // 创建PDF文档，使用A4尺寸，横向布局
      const pdf = new jsPDF('l', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // 设置页面边距（单位：mm）
      const margin = {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10
      };

      // 计算内容区域的宽度和高度
      const contentWidth = pdfWidth - margin.left - margin.right;
      const contentHeight = pdfHeight - margin.top - margin.bottom;

      // 从iframe中获取应用了样式的页面元素
      const styledPages = iframe.contentWindow?.document.querySelectorAll('.print-container');
      if (!styledPages || styledPages.length === 0) {
        throw new Error('无法获取样式化的内容');
      }

      // 处理每一页
      for (let i = 0; i < styledPages.length; i++) {
        const page = styledPages[i] as HTMLElement;

        // 使用html2canvas将页面转为canvas
        const canvas = await html2canvas(page, {
          scale: 2, // 提高清晰度
          useCORS: true,
          logging: false,
          allowTaint: true,
          height: page.scrollHeight, // 确保捕获完整高度
          windowHeight: page.scrollHeight // 设置窗口高度与内容一致
        });

        // 获取canvas的宽高比
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const imgWidth = contentWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // 检查是否需要分页 - 如果内容高度超过页面高度
        if (imgHeight <= contentHeight) {
          // 内容适合一页，直接添加
          if (i > 0) {
            pdf.addPage();
          }
          pdf.addImage(imgData, 'JPEG', margin.left, margin.top, imgWidth, imgHeight);
        } else {
          // 内容需要分页
          // 计算每页在canvas中的高度（像素）
          const pageHeightInCanvas = (contentHeight / imgHeight) * canvas.height;
          const totalPages = Math.ceil(canvas.height / pageHeightInCanvas);

          // 逐页添加内容
          for (let j = 0; j < totalPages; j++) {
            // 如果不是第一页，添加新页
            if (j > 0 || i > 0) {
              pdf.addPage();
            }

            // 计算当前页在canvas中的起始位置和高度
            const sourceY = j * pageHeightInCanvas;
            const sourceHeight = Math.min(pageHeightInCanvas, canvas.height - sourceY);

            // 创建一个新的canvas来裁剪当前页内容
            const pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvas.width;
            pageCanvas.height = sourceHeight;

            const ctx = pageCanvas.getContext('2d');
            if (ctx) {
              // 将原始canvas的对应部分绘制到新canvas上
              ctx.drawImage(
                canvas,
                0, sourceY, canvas.width, sourceHeight,
                0, 0, canvas.width, sourceHeight
              );

              // 将新canvas转为图像数据
              const pageImgData = pageCanvas.toDataURL('image/jpeg', 1.0);

              // 计算实际高度比例
              const pageImgHeight = (sourceHeight / canvas.width) * imgWidth;

              // 添加到PDF
              pdf.addImage(
                pageImgData,
                'JPEG',
                margin.left,
                margin.top,
                imgWidth,
                pageImgHeight
              );
            }
          }
        }
      }

      // 保存PDF文件
      const fileName = `维修结算单_${moment().format('YYYYMMDDHHmmss')}.pdf`;
      pdf.save(fileName);
      message.success('PDF导出成功');
    } catch (error) {
      console.error('PDF导出失败:', error);
      message.error('PDF导出失败，请重试');
    } finally {
      setExporting(false);
    }
  };

  return (
    <Modal
      title="打印详情"
      width={1300}
      visible={printSettleVisible}
      onCancel={() => setPrintSettleVisible(false)}
      footer={[
        <Button type="primary" onClick={() => setPrintSettleVisible(false)} key="back"> 取消</Button>,
        <Button type="primary" onClick={print} key="submit">打印</Button>,
        <Button type="primary" onClick={exportToPdf} loading={exporting} key="export">导出pdf</Button>,
      ]}
    >
      <YhBox style={{ height: 'calc(100vh - 250px)', overflow: 'auto' }}>
        <div id="public-print-container">
          {Array.from({ length: pageCount }).map((_, pageIndex) => (
            <div className="print-container finance">
              <h2>{`${shopName}修理结算单`}</h2>
              <ul className="header-odd">
                <li>单据编号：{dataSource[pageIndex]?.maintenanceCode}    ({getTreeNodeName(dataSource[pageIndex]?.status)})</li>
                <li>结算方：{dataSource[pageIndex]?.settlementPartyName}</li>
                <li>结算类型：{getTreeNodeName(dataSource[pageIndex]?.payType as string)}</li>
                <li>打印日期：{moment(new Date()).format("YYYY-MM-DD HH:mm")}</li>
              </ul>
              <table className="news-table">
                <tbody>
                  <tr>
                    <td>车牌</td>
                    <td>{dataSource[pageIndex]?.licensePlate}</td>
                    <td>客户名称</td>
                    <td style={{ textAlign: "left" }} colSpan={7}>{dataSource[pageIndex]?.customerName}</td>
                  </tr>
                  <tr>
                    <td>所属站点</td>
                    <td >{dataSource[pageIndex]?.shopName}</td>
                    <td>送修人</td>
                    <td >{dataSource[pageIndex]?.contact}</td>
                    <td>电话</td>
                    <td >{dataSource[pageIndex]?.phone}</td>
                    <td>业务员</td>
                    <td >{dataSource[pageIndex]?.createUser}</td>
                    <td>部门负责人</td>
                    <td>{shopCode == 'SHOP-M-00000005' ? '臧润祥' : ''}</td>
                  </tr>
                  <tr>
                    <td>车型</td>
                    <td colSpan={3}>{dataSource[pageIndex]?.brandName}({dataSource[pageIndex]?.vehicleTypeName})</td>
                    <td>公里数</td>
                    <td >{dataSource[pageIndex]?.mileage}</td>
                    <td>送修日期</td>
                    <td>{dataSource[pageIndex]?.enterTime}</td>
                    <td>竣工日期</td>
                    <td >{dataSource[pageIndex]?.completeTime}</td>
                  </tr>
                  <tr>
                    <td>VIN</td>
                    <td style={{ textAlign: "left" }} colSpan={9}>{dataSource[pageIndex]?.vin}</td>
                  </tr>
                  <tr>
                    <td>故障描述</td>
                    <td style={{ textAlign: "left" }} colSpan={9}>{dataSource[pageIndex]?.faultDesc}</td>
                  </tr>
                  <tr>
                    <td>维修附加项</td>
                    <td style={{ textAlign: "left" }} colSpan={9}>{dataSource[pageIndex]?.additionalItems}</td>
                  </tr>
                </tbody>
              </table>
              <table className="item-table">
                <tbody>
                  {dataSource[pageIndex]?.itemDetailList?.length > 0 &&
                    <tr className="print-center" >
                      <td style={{ width: 40 }}>序号</td>
                      <td>项目编号</td>
                      <td>项目名称</td>
                      <td>工时费</td>
                      <td>工时</td>
                      <td>实际工时</td>
                    </tr>
                  }
                  {dataSource[pageIndex]?.itemDetailList?.map((row: any, rowIndex: any) => (
                    <tr className="print-center">
                      <td>{rowIndex + 1}</td>
                      <td>{row.itemCode}</td>
                      <td>{row.itemName}</td>
                      <td>{row.receivableAmount}</td>
                      <td>{row.workHour}</td>
                      <td>{row.workHour}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <table className="material-table">
                <tbody>
                  {dataSource[pageIndex]?.materialDetailList?.length > 0 &&
                    <tr className="print-center" >
                      <td style={{ width: 60 }}>序号</td>
                      <td>材料编号</td>
                      <td>材料名称</td>
                      <td>单位</td>
                      <td>数量</td>
                      <td>单价</td>
                      <td>金额</td>
                      <td>备注</td>
                    </tr>
                  }
                  {dataSource[pageIndex]?.materialDetailList?.map((row: any, rowIndex: any) => (
                    <tr className="print-center">
                      <td>{rowIndex + 1}</td>
                      <td>{row.materialCode}</td>
                      <td>{row.materialName}</td>
                      <td>{row.unitName}</td>
                      <td>{row.num}</td>
                      <td>{fmoney(row.price, 2)}</td>
                      <td>{fmoney(row.receivableAmount, 2)}</td>
                      <td>{row.note}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <table className="news-table footer-table">
                <tbody>
                  <tr>
                    <td>工时费</td>
                    <td>{fmoney(dataSource[pageIndex]?.workingHoursAmount, 2)}</td>
                    <td>材料费</td>
                    <td>{fmoney(dataSource[pageIndex]?.materialScienceAmount, 2)}</td>
                    <td>合计金额</td>
                    <td>{fmoney(dataSource[pageIndex]?.totalAmount, 2)}</td>
                    <td>含税合计</td>
                    <td>{fmoney(dataSource[pageIndex]?.totalAmount, 2)}</td>
                  </tr>
                  <tr>
                    <td>优惠金额</td>
                    <td>{fmoney(dataSource[pageIndex]?.discountTotalAmount, 2)}</td>
                    <td>实收金额</td>
                    <td>{fmoney(dataSource[pageIndex]?.receivableTotalAmount, 2)}</td>
                    <td>(大写)</td>
                    <td colSpan={3}>{numberParseChina(dataSource[pageIndex]?.receivableTotalAmount)}</td>
                  </tr>
                  <tr>
                    <td>待结金额</td>
                    <td >{ }</td>
                    <td>客户签字</td>
                    <td>{ }</td>
                    <td>结算人</td>
                    <td>{dataSource[pageIndex]?.reckoner}</td>
                    <td>会计</td>
                    <td></td>
                  </tr>
                </tbody>

              </table>
              <ul className="header-odd">
                <li>制表人：{dataSource[pageIndex]?.createUser}</li>
                <li>蜘蛛网车服</li>
                <li>第1页/共1页</li>
              </ul>
              <ul className="header-odd">
                <li>备注：{dataSource[pageIndex]?.note}</li>
              </ul>
            </div>
          ))}
        </div>
      </YhBox>
    </Modal>
  )
};